import type { SVGProps } from 'react';
import * as React from 'react';

/* AUTOGENERATED: DO NOT EDIT */
import _styles from '../logo.module.css';
export const MicrosoftIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path fill="#fff" d="M1 1h8.57v8.57H1zM10.43 1H19v8.57h-8.57zM1 10.43h8.57V19H1zM10.43 10.43H19V19h-8.57z" />
  </svg>
);
